import AOS from "aos";
import DataTable from "vanilla-datatables";
import jsPDF from "jspdf";
import axios from "axios";

(function ($) {
	$(window).on("elementor/frontend/init", function () {
		var timeout;

		$(".woocommerce").on("change", "input.qty", function () {
			if (timeout !== undefined) {
				clearTimeout(timeout);
			}

			timeout = setTimeout(function () {
				$("[name='update_cart']").trigger("click");
			}, 500); // 1 second delay, half a second (500) seems comfortable too
		});

		$("input.qty").trigger("change");
	});
})(jQuery);

function download_csv(csv, filename) {
	var csvFile;
	var downloadLink;
	csvFile = new Blob([csv], { type: "text/csv" });
	downloadLink = document.createElement("a");
	downloadLink.download = filename;
	downloadLink.href = window.URL.createObjectURL(csvFile);
	downloadLink.style.display = "none";
	document.body.appendChild(downloadLink);
	downloadLink.click();
}

function export_table_to_csv(html, filename) {
	var csv = [];
	var rows = document.querySelectorAll("table tr");
	for (var i = 0; i < rows.length; i++) {
		var row = [],
			cols = rows[i].querySelectorAll("td, th");
		for (var j = 0; j < cols.length; j++) row.push(cols[j].innerText);
		csv.push(row.join(","));
	}
	download_csv(csv.join("\n"), filename);
}

window.addEventListener("DOMContentLoaded", () => {
	AOS.init({
		once: true,
		duration: 800,
		easing: "ease-out-back",
		mirror: false,
	});

	let filter_form = document.querySelector("form.inpage");
	let bons_achat = document.querySelectorAll(".bons");
	let burger = document.querySelector("#main-nav .hamburger");
	let mycodes = document.getElementById("myDataTable");
	let nom_commercant = document.getElementById("nom_commercant");
	let totalrecolte = document.getElementById("totalrecolte");
	let totalrestant = document.getElementById("totalrestant");
	if (totalrecolte && totalrestant) {
		totalrecolte.querySelector(".elementor-heading-title").innerHTML = '<i class="fal fa-spinner fa-spin"></i>';
		totalrestant.querySelector(".elementor-heading-title").innerHTML = '<i class="fal fa-spinner fa-spin"></i>';

		axios.get("https://jaidemescommercants.fr/api/custom_service/?service=get_total_orders").then((res) => {
			let total1 = res.data.result.total;
			let total2 = res.data.result.total_urca;

			totalrecolte.querySelector(".elementor-heading-title").innerHTML = Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(total1);
			totalrestant.querySelector(".elementor-heading-title").innerHTML = Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(total2);
		});
	}
	if (nom_commercant) {
		nom_commercant.addEventListener("keyup", (e) => {
			let commerces = document.querySelectorAll(".commerces");
			if (e.target.value.length >= 3) {
				commerces.forEach((item) => {
					let titre2 = item.querySelector("h2");
					if (
						titre2.innerText
							.toLowerCase()
							.normalize("NFD")
							.replace(/[\u0300-\u036f]/g, "")
							.includes(
								e.target.value
									.toLowerCase()
									.normalize("NFD")
									.replace(/[\u0300-\u036f]/g, "")
							)
					) {
						item.classList.remove("hidden");
					} else {
						item.classList.add("hidden");
					}
				});
			} else {
				commerces.forEach((item) => {
					item.classList.remove("hidden");
				});
			}
			AOS.refresh();
		});
	}

	if (mycodes) {
		let impression = document.getElementById("imprimer");

		let excel = document.getElementById("excel");
		if (excel) {
			excel.addEventListener("click", () => {
				var html = mycodes.outerHTML;
				export_table_to_csv(html, "export-ventes.csv");
			});
		}

		let mydataTable = new DataTable(mycodes, {
			perPage: 1000,
			labels: {
				placeholder: "Client, réference, ...",
				perPage: "{select} résultats par page",
				noRows: "Aucun bon trouvé",
				info: "Affichage de {start} à {end} sur {rows} bons d'achat",
			},
		});
		if (impression) {
			impression.addEventListener("click", () => {
				mydataTable.print();
			});
		}
	}

	burger.addEventListener("click", () => {
		if (burger.classList.contains("active")) {
			burger.classList.remove("active");
		} else {
			burger.classList.add("active");
		}
	});

	if (filter_form) {
		let ville = document.getElementById("ville").value;
		let categorie = document.getElementById("categorie").value;

		filter_form.addEventListener("submit", (e) => {
			e.preventDefault();
			ville = document.getElementById("ville").value;
			categorie = document.getElementById("categorie").value;
			let commerces = document.querySelectorAll(".commerces");
			if (ville == "" || ville == "tous") {
				ville = "allville";
			}
			if (categorie == "" || categorie == "tous") {
				categorie = "alltype";
			}

			commerces.forEach((item) => {
				if (item.classList.contains(ville) && item.classList.contains(categorie)) {
					item.classList.remove("hidden");
				} else {
					item.classList.add("hidden");
				}
			});
			AOS.refresh();
		});

		if (ville != "" || categorie != "") {
			ville = document.getElementById("ville").value;
			categorie = document.getElementById("categorie").value;
			let commerces = document.querySelectorAll(".commerces");
			if (ville == "" || ville == "tous") {
				ville = "allville";
			}
			if (categorie == "" || categorie == "tous") {
				categorie = "alltype";
			}

			commerces.forEach((item) => {
				if (item.classList.contains(ville) && item.classList.contains(categorie)) {
					item.classList.remove("hidden");
				} else {
					item.classList.add("hidden");
				}
			});
			AOS.refresh();
		}
	}
	if (bons_achat) {
		bons_achat.forEach((item) => {
			item.addEventListener("click", () => {
				//window.print();

				let bon1 = item.querySelector(".bon-achat-1");
				if (bon1.dataset.utilise != "0") {
					alert("Vous avez déjà utilisé ce bon. Il est impossible de l'imprimer à nouveau.");
					return;
				}
				var doc = new jsPDF();

				doc.setFont("helvetica");
				doc.setFontSize(13);
				doc.setFontType("bold");
				doc.text(20, 20, item.dataset.title);

				// BON 1
				doc.setFontSize(12);
				doc.text(20, 40, "Référence du bon : " + bon1.dataset.ref);
				doc.setFontType("normal");

				doc.setFontSize(9);
				doc.text(20, 50, "Commerçant : ");
				doc.text(20, 56, "Type : ");
				doc.text(20, 62, "Propriétaire : ");

				doc.setFontType("italic");
				doc.setTextColor(100);
				doc.text(20, 72, "Valide jusqu'au 31/03/2021");
				doc.text(20, 78, "Cumulable avec d'autres bons d'achats. Utilisable une seule fois.");

				doc.setFontType("italic");
				doc.setFontSize(9);
				doc.setTextColor(0);
				doc.setFontType("bold");
				doc.text(50, 50, bon1.dataset.commerce);
				doc.text(50, 56, "Acheté");
				doc.text(50, 62, bon1.dataset.proprio);

				doc.setFontSize(13);
				doc.text(20, 90, "Montant : " + bon1.dataset.total + "€");
				doc.setFontSize(9);
				doc.text(20, 95, "dont " + bon1.dataset.offert + "€ offerts");

				// Séparation
				doc.line(20, 110, 160, 110);

				// Message de remerciements
				var logolz = new Image();
				var logosodec = new Image();
				var logofede = new Image();
				var logocci = new Image();
				var logopaysmont = new Image();
				var logoaudincourt = new Image();
				var logoasso = new Image();
				var logomontbeliard = new Image();
				var logovalentigney = new Image();

				logolz.src = "https://jaidemescommercants.fr/wp-content/files/2020/04/Jaidemescommercants.fr-uncategorized-LZ-111.png";
				logosodec.src = "https://jaidemescommercants.fr/wp-content/files/2020/04/Jaidemescommercants.fr-uncategorized-SODECC-112.png";
				logofede.src = "https://jaidemescommercants.fr/wp-content/files/2020/05/Jaidemescommercants.fr-Partenaires-LOGO-FEDEUC-PMA-13.gif";
				logocci.src = "https://jaidemescommercants.fr/wp-content/files/2020/04/Jaidemescommercants.fr-Partenaires-cci-doubs-07.jpg";
				logopaysmont.src = "https://jaidemescommercants.fr/wp-content/files/2020/04/Jaidemescommercants.fr-Partenaires-PMA-logo-02.png";
				logoaudincourt.src = "https://jaidemescommercants.fr/wp-content/files/2020/04/Jaidemescommercants.fr-Partenaires-ville-audincourt-03.png";
				logoasso.src = "https://jaidemescommercants.fr/wp-content/files/2020/04/Jaidemescommercants.fr-Partenaires-ACA-LOGO-2019-06.jpg";
				logomontbeliard.src = "https://jaidemescommercants.fr/wp-content/files/2020/04/Jaidemescommercants.fr-Partenaires-ville-montbeliard-09.jpg";
				logovalentigney.src = "https://jaidemescommercants.fr/wp-content/files/2020/05/Jaidemescommercants.fr-Partenaires-valentigney-16.png";

				doc.setFontSize(14);
				doc.setFontType("bold");
				doc.text(20, 230, "Jaidemescommerçants.fr");

				doc.setFontSize(11);
				doc.setFontType("bold");
				doc.text(20, 244, "Une initiative de SODECC, créée par l'agence de communication Lézards Création");

				doc.setFontSize(10);
				doc.setFontType("normal");
				doc.text(20, 250, "avec le soutien financier de :");

				// Ajout d'un logo
				doc.addImage(logosodec, "PNG", 20, 260, 16, 16);
				doc.addImage(logolz, "PNG", 38, 260, 16, 16);
				doc.addImage(logofede, "PNG", 56, 260, 16, 16);
				doc.addImage(logocci, "JPG", 74, 260, 16, 16);
				doc.addImage(logopaysmont, "PNG", 92, 260, 16, 16);
				doc.addImage(logoaudincourt, "PNG", 110, 260, 16, 16);
				doc.addImage(logoasso, "JPG", 128, 260, 16, 16);
				doc.addImage(logomontbeliard, "JPG", 146, 260, 16, 16);
				doc.addImage(logovalentigney, "PNG", 164, 260, 16, 16);

				// Sauvegarde
				doc.save("monbon.pdf");
			});
		});
	}

	let elems = Array.prototype.slice.call(document.querySelectorAll(".js-switch"));
	elems.forEach(function (el) {
		var switchery = new Switchery(el, { size: "small", color: "#E6007E" });
		let leparent = el.parentNode.parentNode;
		el.addEventListener("change", () => {
			if (el.checked === true) {
				axios({
					method: "POST",
					url: "https://jaidemescommercants.fr/api/custom_service",
					params: {
						service: "add_use",
						bon_id: el.dataset.bonid,
					},
				})
					.then((res) => {
						if (res.data.result.reponse == "nok") {
							alert("Une erreur est survenue. L'utilisation n'a pas pu validée. ");
						}
						if (res.data.result.reponse == "1") {
							leparent.classList.add("used");
						}
					})
					.catch((error) => {
						console.log(error);
						alert("Une erreur inconnue est survenue");
					});
			} else {
				axios({
					method: "POST",
					url: "https://jaidemescommercants.fr/api/custom_service",
					params: {
						service: "remove_use",
						bon_id: el.dataset.bonid,
					},
				})
					.then((res) => {
						if (res.data.result.reponse == "nok") {
							alert("Une erreur est survenue. L'utilisation n'a pas pas été annulée. ");
						}
						if (res.data.result.reponse == "1") {
							leparent.classList.remove("used");
						}
					})
					.catch((error) => {
						console.log(error);
						alert("Une erreur inconnue est survenue");
					});
			}
		});
	});
});
